import React from 'react';
//import BottomNav from '../BottomNav';

function Dashboard() {
    return (
        <>
            <div>
                <h1>Dashboard</h1>
            </div>
            {/* <BottomNav /> */}
        </>
    )
}

export default Dashboard
